import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true, error: error };
  }

  componentDidCatch(error, errorInfo) {
    // You can also log the error to an error reporting service
    console.error("Uncaught error in ErrorBoundary:", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      // Optionally display the error message for debugging
      return (
        <div style={{ padding: '1rem', border: '1px solid red', margin: '1rem 0', backgroundColor: '#ffeeee' }}>
          <p style={{ color: 'red', fontWeight: 'bold' }}>Algo salió mal al renderizar este componente.</p>
          {process.env.NODE_ENV !== 'production' && this.state.error && (
            <pre style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-all', fontSize: '0.8em' }}>
              {this.state.error.toString()}
            </pre>
          )}
        </div>
      );
    }

    return this.props.children; 
  }
}

export default ErrorBoundary; 